const path = "/app/manage";

export const manageDevicesRouteMeta = [
  {
    type: "redirect",
    key: "MANAGE_DEVICES_AND_GROUPS",
    from: path,
    to: `${path}/device-and-groups`,   
    exact: true,
  },
  {
    type: "route",
    key: "MANAGE_DEVICES_AND_GROUPS",
    path: `${path}/device-and-groups/*`,   //* stays here only
  },
  {
    type: "route",
    key: "CONFIGURATION_PROFILES",
    path: `${path}/create-profile`,
  },
  {
    type: "route",
    key: "CONFIGURATION_PROFILES",
    path: `${path}/profiles-and-policies/*`,
  },
  {
    type: "route",
    key: "DEPLOYMENT_PROFILES",
    path: `${path}/deployment-policy/*`,
  },
  {
    type: "route",
    key: "SOFTWARE_DEPLOYMENT",
    path: `${path}/software-repository/*`,
  },
  {
    type: "route",
    key: "SCRIPTS",
    path: `${path}/scripts-and-remediations/*`,
  },
  {
    type: "inner-route",
    key: "MANAGE_DEVICES_AND_GROUPS_OVERVIEW",
    path: `${path}/overview`,
  },
  {
    type: "route",
    key: "MANAGE_DEVICES_AND_GROUPS_OVERVIEW",
    path: `${path}/overview/:type/:id/:name`,
  },
];